const SECTION_SUFFIX = /\bsection\s*$/i;
const TEAM_PREFIX = /^\[team\]/i;
const PLANFIX_PREFIX = /^\[/;

export function isClothingDepartmentName(name: string): boolean {
  return !!name && (!PLANFIX_PREFIX.test(name) || (SECTION_SUFFIX.test(name) && !TEAM_PREFIX.test(name)));
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/clothing-department.ts